import { Outlet } from 'react-router-dom'
import { useRealtimeBridge } from '../../hooks/useRealtimeBridge'
import { SideNav } from './SideNav'
import { TopBar } from './TopBar'

/** 应用壳：全局挂 MQTT 桥 + 顶栏紧急滚动条 + 侧栏导航 */
export function AppShell() {
  useRealtimeBridge()
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <SideNav />
      <main className="lg:pl-56">
        <div className="mx-auto max-w-[1760px] px-4 pb-10 pt-[6.75rem] lg:px-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
